package uz.ferro.erp.feature.customer.model

import kotlinx.serialization.Serializable

@Serializable
data class SalesPointDto (
    val id: String,
    val whsId: String,
    val customerIdPrefix: String,
    val customerGroupId: Long,
)